<template>
  <div class="wrapper" :class="bgImageUrl ? 'background_shadow' : ''"  :style="{ backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : '' }">
    <div class="title">Hello {{ candidateStore.candidate.first_name }} !</div>
    <div class="block">
      <h2>Bienvenue sur votre espace Yuzu</h2>
      <p>Retrouvez toutes les informations liées à vos évaluations.</p>
    </div>
    <div
      v-if="assessmentStore.assessments.length == 1"
      class="assessments-wrapper"
    >
      <AssessmentCard
        v-for="assessment in assessmentStore.assessments"
        :key="assessment"
        :assessment="assessment"
        :canStart="canStart(assessment)"
        :hasResults="assessmentStore.results ? true : false"
        :isMobile="state.windowWidth < 1024"
        @verifyPhone="openVerifyPhone(assessment)"
        @startAssessment="startAssessment(assessment)"
      />
    </div>
    <carousel
      v-else
      class="slider"
      snap-align="center"
      :wrap-around="true"
      :transition="600"
      :breakpoints="state.carouselBreakpoints"
      ref="gameCarousel"
      @slide-end="handleSlideChanged"
    >
      <Slide
        v-for="(assessment, index) in assessmentStore.assessments"
        :key="index"
        @click="gameCarousel.slideTo(index)"
        class="slide"
      >
        <AssessmentCard
          :assessment="assessment"
          :canStart="canStart(assessment)"
          :hasResults="assessmentStore.results ? true : false"
          :isMobile="state.windowWidth < 1024"
          @verifyPhone="openVerifyPhone(assessment)"
          @startAssessment="startAssessment(assessment)"
        />
      </Slide>
      <template #addons>
        <Pagination />
      </template>
    </carousel>
    <div class="actions-btn">
      <Button
        class="icon icon-left secondary sm no-dark-mode"
        label="Paramètres de votre compte"
        icon="bi-gear"
        @click="state.showAccountModal = true"
      />
    </div>
    <AccountModal
      :isOpen="state.showAccountModal"
      @close="state.showAccountModal = false"
    />
    <LaunchConfirmation
      :isOpen="state.showLaunchConfirmation"
      @close="state.showLaunchConfirmation = false"
    />
    <VerifyPhone
      :isOpen="state.showVerifyPhone"
      @close="state.showVerifyPhone = false"
      @verified="phoneIsVerified()"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import { useCandidateStore } from "@/stores/candidate.js";
import { useAssessmentStore } from "@/stores/assessment.js";
import { useCloudClientStore } from "@/stores/cloud-client.js";
import AssessmentCard from "./partials/AssessmentCard.vue";
import AccountModal from "@/components/modals/game/account/AccountModal.vue";
import LaunchConfirmation from "@/components/modals/game/LaunchConfirmation.vue";
import VerifyPhone from "@/components/modals/game/VerifyPhone.vue";
import "vue3-carousel/dist/carousel.css";
import { getImage } from "@/composables/getImage.js";

const gameCarousel = ref(null);

const candidateStore = useCandidateStore();

const assessmentStore = useAssessmentStore();
const cloudClientStore = useCloudClientStore();

if (assessmentStore.assessments.length < 1) {
  await assessmentStore.getCandidateAssessments();
}

const state = reactive({
  windowWidth: 0,
  showAccountModal: false,
  showLaunchConfirmation: false,
  showVerifyPhone: false,
  carouselBreakpoints: {
    0: {
      itemsToShow: 1,
    },
    767: {
      itemsToShow: 2,
    },
    1000: {
      itemsToShow: 3,
    },
  },
});

function canStart(assessment) {
  const assessmentStarted = assessmentStore.assessments.find(
    (elt) => elt.state === 1
  );

  if (!assessmentStarted) {
    return true;
  }

  return assessment === assessmentStarted;
}

onMounted(() => {
  state.windowWidth = window.innerWidth;

  window.addEventListener("resize", () => {
    if (gameCarousel.value) {
      gameCarousel.value.updateSlideWidth();
    }

    state.windowWidth = window.innerWidth;
  });
});

function startAssessment(assessment) {
  cloudClientStore.init(
    assessment.participant_id,
    assessment.campaign.version,
    assessment.campaign.creation_time,
    assessment.campaign.calibration_id
  );
  state.showLaunchConfirmation = true;
}

function openVerifyPhone(assessment) {
  state.assessment = assessment;
  state.showVerifyPhone = true;
}

function phoneIsVerified() {
  candidateStore.candidate.phone_verified = true;
  state.showVerifyPhone = false;

  if (state.windowWidth > 1024) {
    startAssessment(state.assessment);
  }
}

const bgImageUrl = ref(null);

function handleSlideChanged(slideData) {
  setBGImageFromA(assessmentStore.assessments[slideData.currentSlideIndex]);
}

function setBGImageFromA(assessment) {
  if(assessment.campaign.bg_image_id) {
    const imageBGUrl = getImage(assessment.campaign.bg_image_id);
    bgImageUrl.value = imageBGUrl;
  }
  else {
    bgImageUrl.value = false;
  }
}

setBGImageFromA(assessmentStore.assessments[0]);

</script>
